import React from "react";
import { withRouter } from "react-router-dom";
import { displayScore } from "../../util/stringFormatters/displayScore";
import pendingImg from '../../../../images/pending.png'
import { getScreeningWindow } from "../../../../services/screeningWindowService";
import getWindowFromSeason from "../../util/getWindowFromSeason";
import ARMFloor, { withScoreLessThanDecorator } from "../../blocks/ARMFloor";
import "./GrowthBox.scss";
import { getPR } from "../../functions/getPR";
import getSeason from "../../util/getSeason";

function GrowthBox(props) {
  const { data, scale, history, isPending, embedded, selectedLocale, selectedBenchmark, firstName } = props;

  if(embedded) return null

  const boyArr = [];
  const moyArr = [];
  const eoyArr = [];


  data.forEach((d) => {
    const { storyTags } = d;
    if (!storyTags) return;
    if (storyTags.includes("BOY")) boyArr.push(d);
    if (storyTags.includes("MOY")) moyArr.push(d);
    if (storyTags.includes("EOY")) eoyArr.push(d);
  });

  let boy = boyArr[0];
  let moy = moyArr[0];
  let eoy = eoyArr[0];

  const currentSeason = getScreeningWindow(new Date());

  if (boyArr.length > 1)
    boy = boyArr.reduce((a, b) => (a.date > b.date ? a : b));
  if (moyArr.length > 1)
    moy = moyArr.reduce((a, b) => (a.date > b.date ? a : b));
  if (eoyArr.length > 1)
    eoy = eoyArr.reduce((a, b) => (a.date > b.date ? a : b));

  const handleClick = (eot) => {
    if (eot) history.push(`/teacher/gradebook/scoring/${eot.id}`);
  };

  const handleKey = (e, eot) => {
    if (e.key === "Enter") {
      if (eot) history.push(`/teacher/gradebook/scoring/${eot.id}`);
    }
    if (e.key === "ArrowRight") {
      e.currentTarget.nextSibling && e.currentTarget.nextSibling.focus();
    }
    if (e.key === "ArrowLeft") {
      e.currentTarget.previousSibling &&
        e.currentTarget.previousSibling.focus();
    }
  };

  return (
    <div className="container">
      <Box
        eot={boy}
        term="Fall"
        onClick={() => handleClick(boy)}
        onKeyDown={(e) => handleKey(e, boy)}
        tabIndex="1"
        isLatest={'BOY' === currentSeason}
        isPending={isPending}
        scale={scale}
        selectedLocale={selectedLocale}
        selectedBenchmark={selectedBenchmark}
        firstName={firstName}
      />
      <Box
        eot={moy}
        term="Winter"
        prevTerm={boy ? boy.score : null}
        onClick={() => handleClick(moy)}
        onKeyDown={(e) => handleKey(e, moy)}
        tabIndex="2"
        isLatest={'MOY' === currentSeason}
        isPending={isPending}
        scale={scale}
        selectedLocale={selectedLocale}
        selectedBenchmark={selectedBenchmark}
        firstName={firstName}
      />
      <Box
        eot={eoy}
        term="Spring"
        prevTerm={moy ? moy.score : null}
        prevTerm2={boy ? boy.score : null}
        onClick={() => handleClick(eoy)}
        onKeyDown={(e) => handleKey(e, eoy)}
        tabIndex="3"
        isLatest={'EOY' === currentSeason}
        isPending={isPending}
        scale={scale}
        selectedLocale={selectedLocale}
        selectedBenchmark={selectedBenchmark}
        firstName={firstName}
      />
    </div>
  );
}

function Box(props) {
  const {
    eot,
    term,
    prevTerm = null,
    prevTerm2 = null,
    onClick,
    onKeyDown,
    tabIndex,
    isLatest,
    isPending,
    scale,
    selectedLocale,
    selectedBenchmark,
    firstName,
  } = props;

  let termOverTerm = "";
  let lastScore;
  let date;
  let PR;

  let pendingClass = "progress-pending-img"
  if (isLatest && isPending) pendingClass += " show"

  if (eot) {
    if (prevTerm) {
      lastScore = eot.score - prevTerm;
      if (scale == 'ARM') {
        termOverTerm = `${sign(lastScore.toFixed(2))}`;
      } else {
        termOverTerm = `${sign(Math.round(lastScore))}`;
      }
    }

    if (prevTerm2) {
      const lastScore2 = eot.score - prevTerm2;
      if (scale == 'ARM') {
        termOverTerm = `/${sign(lastScore2.toFixed(2))}`;
      } else {
        termOverTerm += `/${sign(Math.round(lastScore2))}`;
      }
    }

    date = new Date(eot.date).toLocaleDateString();
  }

  if(eot?.date) {
    const season = getSeason(eot.date);
    const window = getWindowFromSeason(season);
    PR = getPR({
      score: eot.score,
      scale,
      grade: selectedBenchmark.grade,
      language: selectedLocale,
      window,
    });
  }
  
  const displayedScore = displayScore(parseFloat(parseFloat(eot && eot.score).toFixed(2)))
  return (
    <div
      className="box"
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
    >
      <div className="inner-box">
        <div className="box-section"/>
        <div className="box-section-main">
          <div>{term}</div>
          <div className="main-score">
            <ARMFloor percentile={PR} metric={scale} firstName={firstName} grade={selectedBenchmark?.grade} benchmarkName={selectedBenchmark.label} locale={selectedLocale}/>
            {withScoreLessThanDecorator({percentile: PR, metric: scale, grade: selectedBenchmark?.grade, displayedString: displayedScore, locale: selectedLocale})}
            {termOverTerm.length > 0 && (
              <div className="sub-score">{termOverTerm}</div>
              )}
          </div>
          <div>{eot ? date : <br />}</div>
        </div>
        <div className="box-section">
          <img className={pendingClass} src={pendingImg}/>
        </div>
      </div>
    </div>
  );
}

function sign(n) {
  return n >= 0 ? `+${n}` : `${n}`;
}

export default withRouter(GrowthBox);